import { TimeIcon } from "@chakra-ui/icons"
import {
    Box,
    IconButton,
    Popover,
    PopoverArrow,
    PopoverBody,
    PopoverContent,
    PopoverTrigger,
    VStack,
} from "@chakra-ui/react"

import { DateRangePicker, DateRangeType } from "../../DateRangePicker"

interface DateRangePickerProps {
    dateRange: DateRangeType
    onChange: (dateRange: DateRangeType) => void
}
const ONE_YEAR_PERIOD_MILLISECOND = 86400 * 1000 * 364
export function DateRangePopover({ dateRange, onChange }: DateRangePickerProps) {
    return (
        <Box>
            <Popover arrowSize={12} colorScheme="blackAlpha" closeOnBlur>
                <PopoverTrigger>
                    <Box>
                        <IconButton isRound variant="link" size="xs" icon={<TimeIcon />} aria-label={""} />
                    </Box>
                </PopoverTrigger>
                <PopoverContent mx={4}>
                    <PopoverArrow />
                    <PopoverBody>
                        <VStack>
                            <DateRangePicker
                                startDate={dateRange[0]}
                                endDate={dateRange[1]}
                                onChange={onChange}
                                maxDate={new Date()}
                                minDate={new Date(Date.now() - ONE_YEAR_PERIOD_MILLISECOND)}
                            />
                        </VStack>
                    </PopoverBody>
                </PopoverContent>
            </Popover>
        </Box>
    )
}
